export const BenefitGroup = Object.freeze({
    "Ineligible": 0,
    "FullTime": 1,
    "Executive": 2
})